import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { getOrCreateDockPortal } from './tawkToWidget/api';
import { useTawkEmbed } from './tawkToWidget/useTawkEmbed';
import styles from './TawkToWidget.module.css';

const EASE = [0.22, 1, 0.36, 1];

function HelpIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true">
      <path
        d="M7.6 8.6a4.4 4.4 0 0 1 8.5 1.7c0 2.7-4.1 3.1-4.1 5.3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12" cy="18.2" r="1.2" fill="currentColor" />
    </svg>
  );
}

function ChevronRight() {
  return (
    <svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true">
      <path
        d="M6 4l4 4-4 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function TawkToWidget({ themeRootRef } = {}) {
  const { chatOpen, openTeamChat } = useTawkEmbed(themeRootRef);

  return createPortal(
    <div className={styles.root}>
      <AnimatePresence>
        {!chatOpen && (
          <motion.button
            key="dock"
            type="button"
            className={styles.dock}
            onClick={openTeamChat}
            aria-label="Need more help? Chat directly with our team"
            style={{ originX: 1, originY: 1 }}
            initial={{ opacity: 0, y: 12, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            transition={{ duration: 0.26, ease: EASE }}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
          >
            <span className={styles.headsetCircle} aria-hidden="true">
              <HelpIcon />
            </span>
            <span className={styles.dockText}>
              <span className={styles.dockTitle}>Need more help?</span>
              <span className={styles.dockSub}>Chat directly with our team?</span>
            </span>
            <span className={styles.arrowBtn} aria-hidden="true">
              <ChevronRight />
            </span>
          </motion.button>
        )}
      </AnimatePresence>
    </div>,
    getOrCreateDockPortal()
  );
}
